import { MenuItem, MenuList } from "@material-ui/core";
import React, { useContext } from "react";
import { Link, Navigate, Route, Routes, useParams } from "react-router-dom";

import AssetPage from "./configuration/pages/asset";
import EmailAddresses from "./configuration/pages/emailAddresses";
import EmailTopics from "./configuration/pages/emailTopics";
import Jobs from "./configuration/pages/job";
import Logs from "./configuration/pages/log";
import Profiles from "./configuration/pages/profiles";
import ChatComponent from "./configuration/pages/realtime/client";
import QueryCacheInvalidations from "./configuration/pages/realtime/config";
import Settings from "./configuration/pages/settings";
import ShiftsCrews from "./configuration/pages/shifCrew";
import Users from "./configuration/pages/users";
import { GenericPanel } from "./controls";
import { ConfigurationContext } from "./globalContext";

type SectionComponent = {
	path: string;
	sidebar: React.FunctionComponent;
	main: React.FunctionComponent;
	exact?: boolean;
};

export type SidebarType = React.FunctionComponent<{ option?: string }>;

export type ConfigurationsType = [SectionComponent[], SidebarType];

export default function Configuration() {
	const { option } = useParams();

	const [customConfiguration, CustomSidebar] =
		useContext<ConfigurationsType>(ConfigurationContext);

	const routes = [
		{
			path: "/",
			sidebar: () => <div>Configuration</div>,
			main: () => <Navigate to="users" />,
		},
		{
			path: "shifts",
			sidebar: () => <div>Shifts</div>,
			main: () => <ShiftsCrews />,
		},
		{
			path: "asset",
			sidebar: () => <div>Configuration Asset</div>,
			main: () => <AssetPage />,
		},
		{
			path: "users",
			sidebar: () => <div>Users</div>,
			main: () => <Users />,
		},
		{
			path: "profiles",
			sidebar: () => <div>profiles</div>,
			main: () => <Profiles />,
		},
		{
			path: "logs",
			sidebar: () => <div>Logs</div>,
			main: () => <Logs />,
		},
		{
			path: "jobs",
			sidebar: () => <div>Jobs</div>,
			main: () => <Jobs />,
		},
		{
			path: "settings",
			sidebar: () => <div>Settings</div>,
			main: () => <Settings />,
		},
		{
			path: "real-time/client",
			sidebar: () => <div>Client</div>,
			main: () => <ChatComponent />,
		},
		{
			path: "real-time/config",
			sidebar: () => <div>Config</div>,
			main: () => <QueryCacheInvalidations />,
		},
		{
			path: "email-topics",
			sidebar: () => <div>Email Topics</div>,
			main: () => <EmailTopics />,
		},
		{
			path: "email-addresses",
			sidebar: () => <div>Email Addresses</div>,
			main: () => <EmailAddresses />,
		},
		...customConfiguration,
	];
	return (
		<GenericPanel title="Configuration" description="">
			<div className="row" style={{ display: "flex" }}>
				<div
					className="col-md-2 mt-3 pt-0 pr-0 mes-div-submenu"
					style={{ flex: "20%" }}
				>
					<h3 className="mes-menu-group">Plant</h3>
					<MenuList className="mes-submenu">
						<MenuItem selected={option === "shifts"} className="p-0">
							<Link to="/configuration/shifts" className="nav-link">
								Shift / Crews
							</Link>
						</MenuItem>
						<MenuItem selected={option === "asset"} className="p-0">
							<Link to="/configuration/asset" className="nav-link">
								Assets Tree
							</Link>
						</MenuItem>
					</MenuList>
					<h3 className="mes-menu-group">Security</h3>
					<MenuList className="mes-submenu">
						<MenuItem selected={option === "users"} className="p-0">
							<Link to="/configuration/users" className="nav-link">
								Users
							</Link>
						</MenuItem>
						<MenuItem selected={option === "profiles"} className="p-0">
							<Link to="/configuration/profiles" className="nav-link">
								Profiles
							</Link>
						</MenuItem>
					</MenuList>
					<h3 className="mes-menu-group">Emails</h3>
					<MenuList className="mes-submenu">
						<MenuItem selected={option === "email-topics"} className="p-0">
							<Link to="/configuration/email-topics" className="nav-link">
								Email Topics
							</Link>
						</MenuItem>
						<MenuItem selected={option === "email-addresses"} className="p-0">
							<Link to="/configuration/email-addresses" className="nav-link">
								Email Addresses
							</Link>
						</MenuItem>
					</MenuList>
					<CustomSidebar option={option} />
					<h3 className="mes-menu-group">Real Time</h3>
					<MenuList className="mes-submenu">
						<MenuItem selected={option === "real-time"} className="p-0">
							<Link to="/configuration/real-time/client" className="nav-link">
								Client
							</Link>
						</MenuItem>
						<MenuItem selected={option === "real-time"} className="p-0">
							<Link to="/configuration/real-time/config" className="nav-link">
								Config
							</Link>
						</MenuItem>
					</MenuList>
					<h3 className="mes-menu-group">Maintenance</h3>
					<MenuList className="mes-submenu">
						<MenuItem selected={option === "logs"} className="p-0">
							<Link to="/configuration/logs" className="nav-link">
								Logs
							</Link>
						</MenuItem>
						<MenuItem selected={option === "jobs"} className="p-0">
							<Link to="/configuration/jobs" className="nav-link">
								Jobs
							</Link>
						</MenuItem>
						<MenuItem selected={option === "settings"} className="p-0">
							<Link to="/configuration/settings" className="nav-link">
								Settings
							</Link>
						</MenuItem>
					</MenuList>
				</div>
				<div className="col-md-10" style={{ flex: "80%" }}>
					<Routes>
						{routes.map((route, index) => (
							<Route
								key={`${route.path}`}
								path={route.path}
								element={<route.main />}
							/>
						))}
					</Routes>
				</div>
			</div>
		</GenericPanel>
	);
}
